export default __webpack_public_path__ + "static/media/brand-10.833d5b72.png";